import React from 'react';

const Actions = () => {
    return (
        <div className="actions">
            <div className="actions-items">
                <a className="actions-item" href="https://mero.ro/p/novo-glam">
                    <span>Programează-te</span>
                </a>
            </div>
        </div>
    );
};

export default Actions;
